"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TabContent = exports.TabList = exports.Container = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _toColorString = _interopRequireDefault(require("polished/lib/color/toColorString"));

var _color = _interopRequireDefault(require("@decisiv/design-tokens/lib/color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Container = _styledComponents.default.div.withConfig({
  displayName: "styles__Container",
  componentId: "sc-1o82gsh-0"
})(["display:flex;flex-direction:column;"]);

exports.Container = Container;

var TabList = _styledComponents.default.div.withConfig({
  displayName: "styles__TabList",
  componentId: "sc-1o82gsh-1"
})(["align-items:flex-end;border-bottom:1px solid ", ";display:flex;"], (0, _toColorString.default)(_color.default.base.quarterMoon));

exports.TabList = TabList;

var TabContent = _styledComponents.default.div.withConfig({
  displayName: "styles__TabContent",
  componentId: "sc-1o82gsh-2"
})(["&:active,&:focus{outline:none;}"]);

exports.TabContent = TabContent;